



// 



import { Component, OnInit, AfterViewInit, TemplateRef, ViewChild, Input } from '@angular/core';

import { AlertService, DialogType, MessageSeverity } from '../../services/alert.service';
import { AppTranslationService } from "../../services/app-translation.service";
import { AccountService } from '../../services/account.service';
import { Utilities } from '../../services/utilities';
import { Role } from '../../models/role.model';
import { Permission } from '../../models/permission.model';
import { ApiService } from '../../services/api.service';
import * as _ from 'lodash'
import {  BsModalService } from 'ngx-bootstrap/modal';

@Component({
    selector: 'loggers',
    template: require('./loggers.component.html'),
    styles: [require('./loggers.component.css')],
    providers: [BsModalService]
})
export class LoggersComponent implements OnInit, AfterViewInit {
    columns: any[] = [];
    rows: any[] = [];
    rowsCache: any[] = [];
    loadingIndicator: boolean;
    eventLogPagedResult = {
        results: [],
        rowCount: 0,
        currentPage: 0,
        pageSize: 10
    };


    constructor(private alertService: AlertService, private translationService: AppTranslationService, private accountService: AccountService,
    private apiService: ApiService) {
    }


    ngOnInit() {
        let gT = (key: string) => this.translationService.getTranslation(key);

        this.loadData(this.eventLogPagedResult.currentPage + 1, this.eventLogPagedResult.pageSize);
    }





    ngAfterViewInit() {

    }

    onRefresh() {
        this.eventLogPagedResult.results = [];
        this.eventLogPagedResult.currentPage = 0;
        this.loadData(this.eventLogPagedResult.currentPage + 1, this.eventLogPagedResult.pageSize);
    }

    getChangePage(page) {
        // this.page.pageNumber = page.offset
        //console.log(this.page)
        this.eventLogPagedResult.results = [];
        this.loadData(page.offset + 1, this.eventLogPagedResult.pageSize);
    }



    loadData(skip, take) {
        //this.alertService.startLoadingMessage();
        //this.loadingIndicator = true;
        this.apiService.getEventLogsByType('carington', skip, take).subscribe(r => {
            this.eventLogPagedResult = r
            this.eventLogPagedResult.currentPage--
            _.each(r.results, i =>
            {
                //console.log(r)

                //console.log(this.eventLogPagedResult)
                i.isSuccess = i.message.indexOf(`"Success":"True"`) > -1
            })

        })

    }


    onSearchChanged(value: string) {
        this.rows = this.rowsCache.filter(r => Utilities.searchArray(value, false, r.message));
    }

}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/components/loggers/loggers.component.ts